module.exports = __webpack_public_path__ + "media/images/sp/specials/common/plan_yoso_location_green-7a5507c4ada0b4fec464bdfa9387da67.jpg";